import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { TextUpdateMode } from "../../../../types/forms";
var OtherOptionInput = function (_a) {
    var committedValue = _a.committedValue, textUpdateMode = _a.textUpdateMode, isEnabled = _a.isEnabled, label = _a.label, placeholder = _a.placeholder, maxLength = _a.maxLength, sx = _a.sx, onCommit = _a.onCommit;
    var _b = useState(committedValue), localValue = _b[0], setLocalValue = _b[1];
    useEffect(function () {
        setLocalValue(committedValue);
    }, [committedValue]);
    var isOnTyping = textUpdateMode === TextUpdateMode.ON_TYPING;
    var commit = function () {
        if (localValue === committedValue) {
            return;
        }
        onCommit(localValue);
    };
    var handleKeyDown = function (e) {
        if (e.key === "Enter") {
            commit();
        }
    };
    return (_jsx(TextField, { fullWidth: true, sx: sx, label: label, placeholder: placeholder, disabled: !isEnabled, value: localValue, inputProps: { maxLength: maxLength }, onChange: function (e) {
            var inputValue = e.target.value;
            setLocalValue(inputValue);
            if (isOnTyping) {
                onCommit(inputValue);
            }
        }, onBlur: function () {
            if (!isOnTyping) {
                commit();
            }
        }, onKeyDown: isOnTyping ? undefined : handleKeyDown }));
};
export default OtherOptionInput;
